import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface ISocialMediaProps {
  theme: ITheme // TODO:VJ : default import setup to be done
}

export const SocialMedia = styled('div')<ISocialMediaProps>`
  a {
    color: ${(props) => props.theme.colors.textDarkblack};
    margin-right: 20px;
    margin-bottom: 20px;
    @media (min-width: ${(props) => props.theme.mq.sm}) {
      display: block;
    }
    @media (min-width: ${(props) => props.theme.mq.lg}) {
      display: inline;
      margin-right: 40px;
    }
  }
`
